import { PropsWithChildren } from 'react';
import CardContentMUI from '@mui/material/CardContent';

export const CardContent = ({ children }: PropsWithChildren) => <CardContentMUI>{children}</CardContentMUI>;
